/* eslint-disable max-statements */
import React, { useEffect, useRef, useState } from 'react';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Card } from 'primereact/card';
import { Dropdown } from 'primereact/dropdown';
import { Divider } from 'primereact/divider';
import { TieredMenu } from 'primereact/tieredmenu';
import { confirmDialog } from 'primereact/confirmdialog';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { usePostNotifyPeerMutation } from '../../components/webRTC/notifyPeerSlice';

import {
    selectCurrentChatAgtId,
    selectCurrentEmpid,
    selectCurrentUser,
    selectCurrentUserManagerLevel,
    setChatAgtId,
} from '../../pages/login/authSlice';
import ReadStrengths from '../coaching/strengths/readStrengths/ReadStrengths';
import NewStrength from '../coaching/strengths/newStrength/NewStrength';
import ReadConversationLog from '../coaching/conversationLogs/readConversationLog/ReadConversationLog';
import NewConversationLog from '../coaching/conversationLogs/newConversationLog/NewConversationLog';
import CoachingToDoView from '../../components/CoachingToDo/CoachingToDoView';
import CoachingToDo from '../../components/CoachingToDo/CoachingToDo';
import CoachingShoutOut from '../../components/coachingShoutOut/coachingShoutOUt';
import { CoachingEntityTypes, CoachingTabs } from '../../utils/typeConstants';
import { metricValueFormat } from '../../utils/metricValueFormat';
import MetricModal from '../coaching/metrics/MetricModal';
import UpdateStrength from '../coaching/strengths/updateStrength/UpdateStrength';
import { StrengthList } from '../coaching/strengths/types';

import VectorOne from '../../assets/gamePlan/vector-1.svg';
import RankB from '../../assets/RankB.png';
import GamePlanB from '../../assets/GamePlanB.png';
import { actionStyles, GameplanProps, getActionColor } from './gamePlanType';
import { MANAGERDASHBOARD, MYMETRICS, ROLES, STACKRANK } from '../../constants';
import { GameplanVertexAISummary } from './GameplanVertexAISummary/GameplanVertexAISummary';
import { startFloatingRecording } from '../recordingFeature/floatingRecorderSlice';

export const createMenuItemTemplate = (alt: string, label: string, onClick: () => void) => {
    const getImageByLabel = (label: string) => {
        switch (label) {
            case 'Ranking':
                return RankB;
            case 'My Metrics':
                return GamePlanB;
            default:
                return '';
        }
    };
    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onClick();
        }
    };
    const imageSrc = getImageByLabel(label);

    return () => (
        <div
            className="p-menuitem-link"
            role="button"
            tabIndex={0}
            onClick={onClick}
            onKeyDown={handleKeyDown}
        >
            <img src={imageSrc} alt={alt} style={{ width: 16, marginRight: 8 }} />
            <span>{label}</span>
        </div>
    );
};

export const GamePlan = ({ gamePlan }: GameplanProps) => {
    const dispatch = useDispatch();
    const userManagerLevel = useSelector(selectCurrentUserManagerLevel);
    const CurrentChatAgtId = useSelector(selectCurrentChatAgtId);
    const [showNewStrengthModal, setShowNewStrengthModal] = useState(false);
    const [shoutoutVisible, setShoutoutVisible] = useState(false);
    const [todoVisible, setTodoVisible] = useState(false);
    const [showNewConversationModal, setshowNewConversationModal] = useState(false);
    const [viewState, setViewState] = useState<string>('new');
    const loggedEmpNum = useSelector(selectCurrentEmpid);
    const loggedEmpUserName = useSelector(selectCurrentUser);
    const [currentRowData, setCurrentRowData] = useState<any>();
    const [strength, setStrength] = useState<StrengthList | undefined>(undefined);
    const [showMetricModal, setShowMetricModal] = useState(false);
    const [rows, setRows] = useState<number>(30);
    const [gamePlanData, setGamePlanData] = useState<any>();
    const [seletedRowData, setSeletedRowData] = useState<any>();
    const [hideMyMetricRankingMenu, setHideMyMetricRankingMenu] = useState(true);
    const menu = useRef<TieredMenu>(null);
    const navigate = useNavigate();
    const [summaryVisible, setSummaryVisible] = useState(false);

    const [postNotifyPeer] = usePostNotifyPeerMutation();
    // const currentUserName = useSelector(selectCurrentUser);
    const authFullState: any = useSelector((state: any) => state.auth);
    const teamLeadFullName = authFullState?.userNameWithId
        ? (() => {
            const nameOnly = authFullState.userNameWithId.replace(/\s*\(\d+\)/, '').trim();
            const parts = nameOnly.split(',').map((p: string) => p.trim());
            return parts.length === 2 ? `${parts[1]} ${parts[0]}` : loggedEmpUserName;
        })()
        : loggedEmpUserName;

    const startCall = async (callerId: string, calleeId: string, calleeName: string) => {
        console.log(`Notification sending to : ${calleeId}`);
        toast.success(`Notification sending to : ${calleeName}`);

       try {
                   await postNotifyPeer({
                       callerId,
                       calleeId,
                    //    message: `${currentUserName.replace(/\s*\(Impersonating\)\s*/g, ' ').trim()} is requesting a call`,
                    message: `${teamLeadFullName.replace(/\s*\(Impersonating\)\s*/g, ' ').trim()} is requesting a call`,
                   }).unwrap()
                   .then((response:any) => {
                       if(response.message === "callee_not_connected")
                       {
                           toast.warn(`${calleeName} is off-line.`);
                           window.dispatchEvent(new CustomEvent('agentOffline', { detail: { offline: true } }));
                       }
                       if(response.message === "notification_sent")
                       {
                           toast.success(`Notification sent to ${calleeName}.`);
                       }
                   })
                   .catch((response:any) => {
                       console.error('Error sending notification:', response);
                       toast.error(`Failed to send notification to ${calleeName}.`);
                   });
               } catch (error) {
                   toast.error(`Failed to send notification to ${calleeName}.`);
                   console.error("Failed to send notify request", error);
               }


        
   
  };

    const onRankingClicked = () => {
        navigate(
            `${STACKRANK}/${seletedRowData?.employee_number}/${seletedRowData?.scorecard_version_id}/${seletedRowData?.year}/${seletedRowData?.month}`,
            { replace: true }
        );
    };
    const onMyMetricsClicked = () => {
        if (ROLES.Supervisor2AndAbove.includes(userManagerLevel)) {
            navigate(
                `${MANAGERDASHBOARD}/0/${seletedRowData?.scorecard_version_id}/${seletedRowData?.year}-${seletedRowData?.month}/${seletedRowData?.employee_number}`,
                { replace: true }
            );
        } else {
            navigate(
                `${MYMETRICS}/${seletedRowData?.employee_number}/${seletedRowData?.scorecard_version_id}/${seletedRowData?.year}-${seletedRowData?.month}`,
                { replace: true }
            );
        }
    };
    const onSummaryCliked = () => {
        setSummaryVisible(true);
    };

    const onVoiceRecordingClicked = () => {
        dispatch(startFloatingRecording({
            callerId: loggedEmpNum,
            calleeId: seletedRowData?.employee_number ?? '',
            associateName: seletedRowData?.employee_name ?? '',
        }));
    };

    const onInitiateCallClicked = () => {
        const empId = seletedRowData?.employee_number;
        const empName = seletedRowData?.employee_name;
        console.log('Row-Clicked : Initiating call for empId:', empId);
        
        // Check if a call is already active
        if (CurrentChatAgtId) {
            const currentAgentName = sessionStorage.getItem('chatAgentName') || 'another agent';
            confirmDialog({
                header: null,
                message: (
                    <div className="dialog-message">
                        <i className="pi pi-exclamation-triangle gradient-icon" style={{ color: '#ff9800' }} />
                        <strong>Call Already in Progress!</strong>
                        <p style={{ marginTop: '8px' }}>You are currently on a call with {currentAgentName}. Please end your current call before starting a new one.</p>
                    </div>
                ),
                icon: null,
                acceptLabel: 'End Current Call & Start New',
                rejectLabel: 'Cancel',
                acceptClassName: 'custom-accept-btn',
                rejectClassName: 'custom-reject-btn',
                position: 'center',
                accept: () => {
                    console.log('Ending current call and starting new call');
                    // End current call first
                    dispatch(setChatAgtId(null));
                    sessionStorage.removeItem('chatAgentName');
                    
                    // Wait for cleanup, then start new call
                    setTimeout(() => {
                        if (empId) {
                            dispatch(setChatAgtId(empId));
                            sessionStorage.setItem('chatAgentName', empName);
                            startCall(loggedEmpNum, empId, empName);
                        }
                    }, 500);
                },
                reject: () => {
                    console.log('User cancelled starting new call');
                },
            });
            return;
        }
        
        // No active call, proceed normally
        if (empId) {
            dispatch(setChatAgtId(empId));
            sessionStorage.setItem('chatAgentName', empName);
            startCall(loggedEmpNum, empId, empName);
        } else {
            dispatch(setChatAgtId(null));
            sessionStorage.removeItem('chatAgentName');
        }
    };

   const items = [];
    items.push(
        {
            label: 'Ranking',
            template: createMenuItemTemplate('Ranking', 'Ranking', onRankingClicked),
            visible: !!hideMyMetricRankingMenu,
        },
        // { separator: showSeparator(), visible: showSeparator() },
        {
            label: 'My Metrics',
            template: createMenuItemTemplate('My Metrics', 'My Metrics', onMyMetricsClicked),
            visible: !!hideMyMetricRankingMenu,
        },
        {
            label: 'Summary',
            icon: 'pi pi-user',
            command: () => {
                onSummaryCliked();
            },
        },
        
    );

    
    items.push(
        {
            label: 'Recording',
            icon: 'pi pi-stop-circle',
            items: [
                {
                    label: 'Call',
                    icon: 'pi pi-phone',
                    command: () => {
                        onInitiateCallClicked();
                    },
                },
                {
                    label: 'Side by Side',
                    icon: 'pi pi-users',
                    command: () => {
                        onVoiceRecordingClicked();
                    },
                },
            ],
        }
    );

    const handleActionsClick = (rowData: any, actionName: string) => {
        setCurrentRowData(rowData);

        if (actionName === 'ToDo') {
            setViewState('new');
            setTodoVisible(true);
        } else if (actionName === 'ShoutOut') {
            if (rowData.gameplan_action_id === 3) setShoutoutVisible(true);
        } else if (actionName === 'Strength') {
            setViewState(rowData.strengths ? 'read' : 'new');
            setShowNewStrengthModal(true);
        } else if (actionName === 'Discussion') {
            setViewState(rowData.discussions ? 'read' : 'new');
            setshowNewConversationModal(true);
        } else if (actionName === 'Metric') {
            setShowMetricModal(true);
        }
    };

    const renderSummaryModals = () => {
        return (
            <GameplanVertexAISummary
                setDisplayModal={setSummaryVisible}
                displayModal={summaryVisible}
                authorId={loggedEmpNum}
                seletedRowData={seletedRowData}
            />
        );
    };

    const renderMetric = () => {
        return (
            <MetricModal
                setDisplayModal={setShowMetricModal}
                displayModal={showMetricModal}
                authorId={loggedEmpNum}
                recipientId={currentRowData?.employee_number}
                inputYear={currentRowData?.year}
                inputMonth={currentRowData?.month}
                recipientName={currentRowData?.employee_name}
                inputScorecardId={currentRowData?.scorecard_id}
                metricId={currentRowData?.metric_id}
                // via={CoachingTabs.GamePlan}
                gameplanId={currentRowData?.gameplan_id}
                entityTypeId={CoachingEntityTypes.Gameplan}
            />
        );
    };

    const renderStrenghtsModal = () => {
        if (viewState === 'read') {
            return (
                <ReadStrengths
                    OnViewState={setViewState}
                    OnDisplayModal={setShowNewStrengthModal}
                    OnEditStrength={setStrength}
                    displayModal={showNewStrengthModal}
                    authorId={loggedEmpNum}
                    recieverId={currentRowData?.employee_number}
                    receiverName={currentRowData?.employee_name}
                    month={new Date(currentRowData?.startDate).getMonth() + 1}
                    year={new Date(currentRowData?.startDate).getFullYear()}
                    via={CoachingTabs.GamePlan}
                    coachingEntityId={currentRowData?.gameplan_id}
                />
            );
        } else if (viewState === 'new') {
            return (
                <NewStrength
                    OnViewState={setViewState}
                    OnDisplayModal={setShowNewStrengthModal}
                    displayModal={showNewStrengthModal}
                    authorId={loggedEmpNum}
                    authorName={loggedEmpUserName}
                    recieverId={currentRowData?.employee_number}
                    receiverName={currentRowData?.employee_name}
                    parentStrengthViewState={'new'}
                    via={CoachingTabs.GamePlan}
                    month={new Date(currentRowData?.startDate).getMonth() + 1}
                    year={new Date(currentRowData?.startDate).getFullYear()}
                    coachingEntityId={currentRowData?.gameplan_id}
                    coachingEntityTypeId={CoachingEntityTypes.Gameplan}
                />
            );
        } else if (viewState === 'edit') {
            return (
                <UpdateStrength
                    OnViewState={setViewState}
                    OnDisplayModal={setShowNewStrengthModal}
                    displayModal={showNewStrengthModal}
                    strength={strength}
                    authorName={loggedEmpUserName}
                    recieverId={currentRowData?.employee_number}
                    receiverName={currentRowData?.employee_name}
                    month={strength?.strength_date ? new Date(strength?.strength_date).getMonth() + 1 : 0}
                    year={strength?.strength_date ? new Date(strength?.strength_date).getFullYear() : 0}
                />
            );
        }
        return '';
    };
    const renderDiscussionModal = () => {
        if (viewState === 'read') {
            return (
                <ReadConversationLog
                    setViewState={setViewState}
                    setDisplayModal={setshowNewConversationModal}
                    viewState={viewState}
                    displayModal={showNewConversationModal}
                    authorId={loggedEmpNum}
                    authorName={loggedEmpUserName}
                    recieverId={currentRowData?.employee_number}
                    inputYear={currentRowData.year}
                    inputMonth={currentRowData.month}
                    receiverName={currentRowData?.employee_name}
                    via={CoachingTabs.GamePlan}
                    coachingEntityId={currentRowData?.gameplan_id}
                    isRecipient
                />
            );
        } else if (viewState === 'new') {
            return (
                <NewConversationLog
                    setViewState={setViewState}
                    setDisplayModal={setshowNewConversationModal}
                    viewState={viewState}
                    displayModal={showNewConversationModal}
                    authorId={loggedEmpNum}
                    authorName={loggedEmpUserName}
                    recieverId={currentRowData?.employee_number}
                    receiverName={currentRowData?.employee_name}
                    via={CoachingTabs.GamePlan}
                    date={new Date()}
                    coachingEntityId={currentRowData?.gameplan_id}
                    coachingEntityTypeId={CoachingEntityTypes.Gameplan}
                />
            );
        }
        return '';
    };
    const renderTodoModal = () => {
        const match = currentRowData?.employee_number.match(/\((\d+)\)/);
        let agentNumber = '';
        if (match) {
            agentNumber = match[1];
        }
        if (viewState === 'read') {
            const todoView: any = { employeeNumber: agentNumber };
            return (
                <CoachingToDoView
                    visible={todoVisible}
                    setVisible={setTodoVisible}
                    selectedToDoViewData={todoView}
                    //via={CoachingTabs.GamePlan}
                    //coachingEntityId={currentRowData?.gameplan_id}
                />
            );
        } else if (viewState === 'new') {
            return (
                <CoachingToDo
                    receiverId={currentRowData?.employee_number}
                    receiverName={currentRowData?.employee_name}
                    visible={todoVisible}
                    setVisible={setTodoVisible}
                    coachingEntityId={currentRowData?.gameplan_id}
                    coachingEntityTypeId={CoachingEntityTypes.Gameplan}
                    coachingStatusId={1}
                    via={CoachingTabs.GamePlan}
                />
            );
        }
        return '';
    };
    const renderShuotOutModal = () => {
        return (
            <CoachingShoutOut
                receiverId={currentRowData?.employee_number}
                receiverName={currentRowData?.employee_name}
                visible={shoutoutVisible}
                setVisible={setShoutoutVisible}
                coachingEntityId={currentRowData?.gameplan_id}
                coachingEntityTypeId={CoachingEntityTypes.Gameplan}
                coreValueId={0}
                via={CoachingTabs.GamePlan}
            />
        );
    };

    const createButtonsTemplate = (rowData: any) => {
        let shoutOutTitle = rowData.shoutouts ? 'Shout Out Created' : 'No Shout Out created';
        if (rowData?.gameplan_action_id !== 3) {
            shoutOutTitle = 'Only allowed if recommendation is "Recognize"';
        }
        const buttons = [
            {
                actionName: 'Metric',
                type: 'Metrics',
                color: 'var(--dark-teal)',
                borderColor: '#00b6b2',
                actionCreated: rowData.metrics,
                title: rowData.metrics ? 'Metric goals created' : 'Metric goals not created',
            },
            {
                actionName: 'Discussion',
                type: 'Discussion',
                color: 'var(--medium-blue)',
                borderColor: '#3299ff',
                actionCreated: rowData.discussions,
                title: rowData.discussions ? 'Discussion Created' : 'No Discussion created',
            },
            {
                actionName: 'Strength',
                type: 'Strength',
                color: 'var(--dark-purple)',
                borderColor: '#7d71e2',
                actionCreated: rowData.strengths,
                title: rowData.strengths ? 'Strength Created' : 'No Strength created',
            },
            // {
            //     actionName: 'ToDo',
            //     type: 'To Do',
            //     color: 'var(--dark-green)',
            //     borderColor: '#2aa154',
            //     actionCreated: rowData.todos,
            //     title: rowData.todos ? 'To Do Created' : 'No To Do created',
            // },
            {
                actionName: 'ShoutOut',
                type: 'Shout Out',
                color: 'var(--dark-orange)',
                borderColor: '#f15523',
                actionCreated: rowData.shoutouts,
                title: shoutOutTitle,
            },
        ];

        return (
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                {buttons.map((btn, index) => {
                    return (
                        <Button
                            key={`${btn.actionName}-${index}`}
                            onClick={() => handleActionsClick(rowData, btn.actionName)}
                            className="p-button-outlined"
                            style={{
                                height: 'auto',
                                display: 'flex',
                                alignItems: 'center',
                                // gap: '6px',
                                padding: '6px 12px',
                                borderRadius: '30px',
                                borderColor: btn.borderColor,
                                color: btn.color,
                            }}
                            title={btn.title}
                            hidden={btn.actionName === 'ShoutOut' && rowData.gameplan_action_id !== 3}
                        >
                            <i className={btn.actionCreated ? 'pi pi-eye' : 'pi pi-plus-circle'} />
                            <Divider
                                style={{
                                    height: '21px',
                                    margin: '0 0px',
                                    width: '10px',
                                    transform: 'rotate(270deg)',
                                }}
                            />
                            <span style={{ fontWeight: 600 }}>{btn.type}</span>
                        </Button>
                    );
                })}
            </div>
        );
    };

    const recommendationBodyTemplate = (rowData: any) => {
        const action = actionStyles[rowData.gameplan_action_id];
        if (!action) return null;

        return (
            <div style={{ position: 'relative', height: '30px' }}>
                <img
                    src={VectorOne}
                    alt="Vector"
                    style={{
                        position: 'absolute',
                        width: '14px',
                        height: '13px',
                        top: '17px',
                        left: 0,
                    }}
                />
                <Button
                    iconPos="left"
                    style={{
                        backgroundColor: action.color,
                        height: '29px',
                        padding: '4px 8px',
                        borderRadius: '8px',
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '12px',
                        width: '130px',
                        cursor: 'default',
                    }}
                >
                    <img
                        src={action.icon}
                        alt={rowData.gameplan_action_name}
                        style={{ width: '18px', height: '15px' }}
                    />
                    <span>{rowData.gameplan_action_id === 1 ? 'No Data' : rowData.gameplan_action_name}</span>
                </Button>
            </div>
        );
    };

    const popupMenuClickHandler = (e: any, rowData: any) => {
        e.preventDefault();
        if (rowData?.gameplan_action_id === 1) setHideMyMetricRankingMenu(false);
        else setHideMyMetricRankingMenu(true);
        setSeletedRowData(rowData);
        menu.current?.toggle(e);
    };

    useEffect(() => {
        setGamePlanData(gamePlan);
    }, [gamePlan]);

    const metricValueTemplate = (rowData: any) => {
        return (
            <span style={{ color: getActionColor(rowData.gameplan_action_id) }}>
                {metricValueFormat(rowData.metric_value, rowData.metric_type_name)}
            </span>
        );
    };

    const metricTemplate = (rowData: any) => {
        return <span>{rowData.metric_value === null ? '--' : rowData.label}</span>;
    };
    const actionTemplate = (rowData: any) => {
        return (
            <Button
                type="button"
                icon="pi pi-ellipsis-v"
                onClick={(e: any) => {
                    popupMenuClickHandler(e, rowData);
                }}
            />
        );
    };

    return (
        <Card style={{ borderRadius: '30px', padding: '24px' }}>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '24px',
                }}
            >
                <h2 style={{ fontWeight: 'bold', color: '#3f5765', fontSize: '24px' }}>My Team</h2>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <span style={{ fontSize: '14px', fontWeight: 600, color: 'var(--medium-steel)' }}>
                        Show
                    </span>
                    <Dropdown
                        value={rows}
                        options={[5, 10, 20, 30, 40, 50]}
                        onChange={(e) => setRows(e.value)}
                        style={{ width: '87px' }}
                        className="custom-dropdown"
                    />
                </div>
            </div>
            <TieredMenu model={items} popup ref={menu} id="popup_menu" className="headerFeatures" />
            <DataTable
                value={gamePlanData?.data}
                // rowClassName={(data) => (data.highlighted ? 'highlighted-row' : '')}
                style={{ marginBottom: '32px' }}
                emptyMessage="No records found."
                rows={rows}
                className="gameplan"
                paginator={gamePlanData?.data?.length > 5}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            >
                <Column header="Associate" field="employee_name" sortable />
                <Column
                    header="Recommendation"
                    sortField="gameplan_action_name"
                    body={recommendationBodyTemplate}
                    sortable
                />
                <Column header="Metric" body={metricTemplate} sortField="label" sortable />
                <Column header="Value" body={metricValueTemplate} />
                <Column header="Actions" body={createButtonsTemplate} />
                <Column
                    body={actionTemplate}
                    headerStyle={{ width: '2rem', padding: 0 }}
                    style={{ minWidth: '2rem', padding: 0 }}
                />
            </DataTable>
            {showMetricModal && renderMetric()}
            {showNewConversationModal && renderDiscussionModal()}
            {showNewStrengthModal && renderStrenghtsModal()}
            {todoVisible && renderTodoModal()}
            {shoutoutVisible && renderShuotOutModal()}
            {summaryVisible && renderSummaryModals()}
        </Card>
    );
};
